export const STANDARD_SHIPPING_PRICES = {
  US: [
    { weight: 0.1, price: 12 },
    { weight: 0.25, price: 15 },
    { weight: 0.5, price: 22 },
    { weight: 0.75, price: 28 },
    { weight: 1, price: 30.5 },
    { weight: 1.25, price: 34 },
    { weight: 1.5, price: 37.5 },
    { weight: 1.75, price: 41.5 },
    { weight: 2, price: 44.5 },
    { weight: 2.5, price: 51.5 },
    { weight: 3, price: 59.5 },
    { weight: 3.5, price: 66.5 },
    { weight: 4, price: 73.5 },
    { weight: 4.5, price: 80.5 },
    { weight: 5, price: 87.5 },
    { weight: 5.5, price: 95.5 },
    { weight: 6, price: 102.5 },
    { weight: 6.5, price: 109.5 },
    { weight: 7, price: 116.5 },
    { weight: 7.5, price: 123.5 },
    { weight: 8, price: 131.5 },
  ],
};

export const getStandardShippingMinMaxWeightForCountry = (country) => {
  const standardShippingPricesForCountry = STANDARD_SHIPPING_PRICES[country];
  if (
    !standardShippingPricesForCountry ||
    standardShippingPricesForCountry.length < 1
  )
    return null;

  const minWeight = Math.min(
    ...standardShippingPricesForCountry.map((priceItem) => priceItem.weight)
  );
  const maxWeight = Math.max(
    ...standardShippingPricesForCountry.map((priceItem) => priceItem.weight)
  );
  return { minWeight, maxWeight };
};
